import { Box } from "@mui/material";
import React from "react";
import { BGColor02 } from "../configs/styles/muiThemes";
import DashboardLayout from "../components/Layouts/DashboardLayout";
import InventoryAnalysisContent from "./InventoryAnalysis/InventoryAnalysisContent";

function InventoryAnalysis() {
  return (
    <Box sx={styles.container}>
      <DashboardLayout activeMenu="report" activeSubMenu="multiBranchInventoryAnalysis">
        <InventoryAnalysisContent />
      </DashboardLayout>
    </Box>
  );
}

export default InventoryAnalysis;

const styles = {
  container: {
    minHeight: { xs: "calc(100vh - 91px)", md: "100vh" },
    backgroundColor: BGColor02,
  },
};
